import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hasUIRefresh"];
import { SearchInput } from './SearchInput';
import { OldSearchInput } from './OldSearchInput';
import { jsx as _jsx } from "react/jsx-runtime";
export const GlobalSearchMinifiedInput = _ref => {
  let {
      hasUIRefresh = false
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return hasUIRefresh ? /*#__PURE__*/_jsx(SearchInput, Object.assign({}, props)) : /*#__PURE__*/_jsx(OldSearchInput, Object.assign({}, props));
};